const initialState = {
  applicationInboxCount: "",
};

const applicationInboxReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "ApplicationInboxCount":
      return {
        ...state,
        applicationInboxCount: payload,
      };

    default:
      return state;
  }
};

export default applicationInboxReducer;
